import React, { useEffect, useState, useRef } from 'react';
import 'bulma/css/bulma.min.css';
import './Events.css';


import EventSlide1 from './images/event_slide_1.jpg';
import EventSlide2 from './images/event_slide_2.jpg';

const PALETTE = ["#c32f37", "#9bdbff", "#1b41bc", "#515164"];

function Events() {
  const [events, setEvents] = useState([]);
  const [currentSlide, setCurrentSlide] = useState(0);
  const [colorIndex, setColorIndex] = useState(0);
  
  const containerRef = useRef(null);
  const rafRef = useRef(null);
  
  // actual mouse position
  const target = useRef({ x: 0, y: 0 });
  // smoothed position
  const current = useRef({ x: 0, y: 0 });

  const slides = [EventSlide1, EventSlide2];

  // Rotate color every 2.5 seconds
  useEffect(() => {
    const id = setInterval(() => {
      setColorIndex((i) => (i + 1) % PALETTE.length);
    }, 2500);
    return () => clearInterval(id);
  }, []);

  // Update CSS variable when color changes
  useEffect(() => {
    if (!containerRef.current) return;
    containerRef.current.style.setProperty("--gridColor", PALETTE[colorIndex]);
  }, [colorIndex]);

  // Mouse move handler - sets target coords only
  const onMove = (e) => {
    const el = containerRef.current;
    if (!el) return;
    const rect = el.getBoundingClientRect();
    target.current.x = e.clientX - rect.left;
    target.current.y = e.clientY - rect.top;
  };

  // requestAnimationFrame loop for smoothing
  useEffect(() => {
    const el = containerRef.current;
    if (!el) return;

    const tick = () => {
      // easing factor (lower = more lag)
      const ease = 0.12;

      current.current.x += (target.current.x - current.current.x) * ease;
      current.current.y += (target.current.y - current.current.y) * ease;

      el.style.setProperty("--mx", `${current.current.x}px`);
      el.style.setProperty("--my", `${current.current.y}px`);

      rafRef.current = requestAnimationFrame(tick);
    };

    rafRef.current = requestAnimationFrame(tick);
    return () => {
      if (rafRef.current) {
        cancelAnimationFrame(rafRef.current);
      }
    };
  }, []);

  useEffect(() => {
    // Try events.json first; fall back to sessions.json if not present
    fetch('/my-app/events.json')
      .then((response) => {
        if (!response.ok) {
          throw new Error('events.json not found');
        }
        return response.json();
      })
      .then((data) => setEvents(data))
      .catch(() => {
        fetch('/my-app/sessions.json')
          .then((response) => response.json())
          .then((data) => setEvents(data))
          .catch((error) => console.error('Error fetching events:', error));
      });
  }, []);

  useEffect(() => {
    // Auto-rotate slideshow every 4 seconds
    const interval = setInterval(() => {
      setCurrentSlide((prevSlide) => (prevSlide + 1) % slides.length);
    }, 4000);

    return () => clearInterval(interval);
  }, [slides.length]);

  return (
    <div
      ref={containerRef}
      className="events-page"
      onMouseMove={onMove}
      onMouseEnter={() => containerRef.current?.classList.add("hover")}
      onMouseLeave={() => containerRef.current?.classList.remove("hover")}
    >
      <div className="grid-overlay" />
      <div className="events-content">
        <div className="events-container">
          <h1 className="title">Events</h1>
          <p>Browse upcoming and past events.</p>
          
          {/* Slideshow */}
          <div className="events-slideshow">
            <div className="slideshow-wrapper">
              {slides.map((slide, index) => (
                <img
                  key={index}
                  src={slide}
                  alt={`Event slide ${index + 1}`}
                  className={`slideshow-image ${index === currentSlide ? 'active' : ''}`}
                />
              ))}
            </div>
            <p className="slideshow-caption">EVENTS PENDING</p>
          </div>

          <table className="table is-striped is-hoverable">
            <thead>
              <tr>
                <th>Date</th>
                <th>Time</th>
                <th>Location</th>
                <th>Host</th>
              </tr>
            </thead>
            <tbody>
              {events.map((eventItem, index) => (
                <tr key={index}>
                  <td>{eventItem.date}</td>
                  <td>{eventItem.time}</td>
                  <td>{eventItem.location}</td>
                  <td>{eventItem.leader}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}

export default Events;


